import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type cxitCredType = CarrierLogisticsCredType
export const cxitDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const cxit: CarrierDef<cxitCredType> = {
  name: 'CXI Trucking',
  scac: 'cxit',
  ...carrierLogistics,
  engineLayers: ['documents', 'pickup', 'profinder', 'rating', 'tracking'],
  documentTypes: cxitDocumentTypes,
}
